class CartRemoveButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
      cartItems.updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)
class CartRemoveSetButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')

      this.removeSetParent = document.querySelector(`[data-set-ID="${this.dataset.index}"].set-top`)
      this.removeSetItems = Array.from(document.querySelectorAll(`[data-set-ID="${this.dataset.index}"]`))
      this.removeItems = {}

      this.removeSetItems.forEach((setItem) => {
        this.removeItems = { ...this.removeItems, [setItem.dataset.setKey]: 0 }
      })

      cartItems.removeSet(this.removeItems, this.removeSetParent, document.activeElement.getAttribute('name'))
    })
  }
}

customElements.define('cart-remove-set-button', CartRemoveSetButton)

class CartItems extends window.BAO.CustomElement() {
  constructor() {
    super()

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus')

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    // eslint-disable-next-line no-undef
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.onChange,
    )
  }

  onChange(event) {
    if (event.target.classList.contains('quantity__input')) {
      if (event.target.classList.contains('quantity-set')) {
        this.updateSetParent = document.querySelector(`[data-set-ID="${event.target.dataset.index}"].set-top`)
        this.updateSetItems = Array.from(document.querySelectorAll(`[data-set-ID="${event.target.dataset.index}"]`))
        this.updateItems = {}
        this.updateSetItems.forEach((setItem) => {
          this.updateItems = { ...this.updateItems, [setItem.dataset.setKey]: event.target.value }
        })
        this.updateQuantitySet(this.updateItems, this.updateSetParent, document.activeElement.getAttribute('name'))
      } else {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
      }
    } else {
      const updateTarget = event.target.closest('quantity-adjuster').querySelector('input')
      if (updateTarget.classList.contains('quantity-set')) {
        this.updateSetParent = document.querySelector(`[data-set-ID="${updateTarget.dataset.index}"].set-top`)
        this.updateSetItems = Array.from(document.querySelectorAll(`[data-set-ID="${updateTarget.dataset.index}"]`))
        this.updateItems = {}
        this.updateSetItems.forEach((setItem) => {
          this.updateItems = { ...this.updateItems, [setItem.dataset.setKey]: updateTarget.value }
        })
        this.updateQuantitySet(this.updateItems, this.updateSetParent, updateTarget.getAttribute('name'))
      } else {
        this.updateQuantity(updateTarget.dataset.index, updateTarget.value, updateTarget.getAttribute('name'))
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ]
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    // eslint-disable-next-line no-undef
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state)

        if (!parsedState.sections) {
          // eslint-disable-next-line no-undef
          const sections = await fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map(section => section.section)}`)
          parsedState.sections = await sections.json()
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })

        this.updateLiveRegions(line, parsedState.item_count, parsedState)
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`)
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          // eslint-disable-next-line no-undef
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          // eslint-disable-next-line no-undef
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          // eslint-disable-next-line no-undef
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading()
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
        this.disableLoading()
      })
  }

  updateQuantitySet(items, set, name) {
    this.enableLoadingSet(set)

    const body = JSON.stringify({
      updates: items,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    // eslint-disable-next-line no-undef
    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then(async (state) => {
        const parsedState = JSON.parse(state)

        if (!parsedState.sections) {
          // eslint-disable-next-line no-undef
          const sections = await fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map(section => section.section)}`)
          parsedState.sections = await sections.json()
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })

        this.updateLiveRegionsSet(set, parsedState.item_count)

        const lineItem = set
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          // eslint-disable-next-line no-undef
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          // eslint-disable-next-line no-undef
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          // eslint-disable-next-line no-undef
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading()
      })
      .catch(err => {
        console.error(err)
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
        this.disableLoading()
      })
  }

  removeSet(items, set, name) {
    this.enableLoadingSet(set)

    const body = JSON.stringify({
      updates: items,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    // eslint-disable-next-line no-undef
    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.text())
      .then(async (state) => {
        const parsedState = JSON.parse(state)

        if (!parsedState.sections) {
          // eslint-disable-next-line no-undef
          const sections = await fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map(section => section.section)}`)
          parsedState.sections = await sections.json()
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0)
        const cartDrawerWrapper = document.querySelector('cart-drawer')
        const cartFooter = document.getElementById('main-cart-footer')

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
        })

        this.updateLiveRegionsSet(set, parsedState.item_count)

        const lineItem = set
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          // eslint-disable-next-line no-undef
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus()
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          // eslint-disable-next-line no-undef
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          // eslint-disable-next-line no-undef
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        this.disableLoading()
      })
      .catch(err => {
        console.error(err);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'))
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
        this.disableLoading()
      })
  }

  updateLiveRegions(line, itemCount, parsedState) {
    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
    const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const quantityValue = parseInt(quantityElement?.value);

    if (this.currentItemCount === itemCount && updatedValue !== quantityValue) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`)
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`)
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value,
        )
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  updateLiveRegionsSet(set, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = set
      const quantityElement = set.querySelector('.quantity-set')
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value,
        )
    }

    this.currentItemCount = itemCount
    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const loadingOverlays = [...this.querySelectorAll(`#CartItem-${line} .loading-overlay`), ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`)]

    loadingOverlays.forEach((overlay) => overlay.classList.remove('hidden'))

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  enableLoadingSet(set) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')
    set.querySelector('.loading-overlay')?.classList.remove('hidden')
    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super()

      // eslint-disable-next-line no-undef
      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value })
        // eslint-disable-next-line no-undef
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      }, 300))
    }
  })
}
